import { render } from "./CardCorporationLogo.vue?vue&type=template&id=71e5c5f8&ts=true"
import script from "./CardCorporationLogo.vue?vue&type=script&lang=ts"
export * from "./CardCorporationLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__